import React, { useState } from 'react';

export const HeroSection = ({
  headline,
  description,
  primaryCtaText,
  primaryCtaHref = '#',
  secondaryCtaText,
  secondaryCtaHref = '#',
  sliderImages = [],
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToNext = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  const goToPrev = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

  return (
    <section className="py-12 md:py-16" style={{ background: 'linear-gradient(rgb(0, 34, 79) 0%, rgb(66, 2, 67) 100%)' }} data-testid="hero-section">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <p className="text-[#F2C900] font-medium tracking-wide mb-3" style={{ fontSize: '1.0rem' }}>Your #1 Higher Education Consultant</p>
            {headline && <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-5 leading-tight" dangerouslySetInnerHTML={{ __html: headline }}></h1>}
            {description && <div className="text-lg mb-8 leading-relaxed max-w-lg" style={{ color: '#f8fafc' }} dangerouslySetInnerHTML={{ __html: description }}></div>}
            <div className="flex flex-col sm:flex-row gap-4">
              {primaryCtaText && (
                <a href={primaryCtaHref} className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg transition-all duration-200 hover:brightness-110 hover:scale-105" style={{ backgroundColor: 'rgb(242, 201, 0)', color: '#00224F', fontWeight: 600 }} data-testid="hero-primary-cta">
                  {primaryCtaText}
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>
                </a>
              )}
              {secondaryCtaText && (
                <a href={secondaryCtaHref} className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg bg-transparent text-white font-medium transition-all duration-200 hover:bg-white/10" style={{ border: '2px solid #fff' }} data-testid="hero-secondary-cta">
                  {secondaryCtaText}
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                </a>
              )}
            </div>
          </div>

          {sliderImages.length > 0 && (
            <div className="order-1 lg:order-2">
              <div className="relative aspect-[4/3] overflow-hidden rounded-xl">
                {sliderImages.map((image, index) => (
                  <div key={index} className={`absolute inset-0 transition-opacity duration-500 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}>
                    <img 
                      src={image.imageUrl} 
                      alt={image.alt || `Slide ${index + 1}`} 
                      className="w-full h-full object-cover" 
                      loading={index === 0 ? "eager" : "lazy"} 
                      fetchPriority={index === 0 ? "high" : "auto"}
                      width={index === 0 ? "1320" : undefined}
                      height={index === 0 ? "990" : undefined}
                    />
                  </div>
                ))}
                {sliderImages.length > 1 && (
                  <>
                    <button onClick={goToPrev} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 hover:bg-white transition-colors" aria-label="Previous">
                      <svg className="w-5 h-5 text-[#00224F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                    </button>
                    <button onClick={goToNext} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 hover:bg-white transition-colors" aria-label="Next">
                      <svg className="w-5 h-5 text-[#00224F]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                    </button>
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                      {sliderImages.map((_, index) => (
                        <button key={index} onClick={() => setCurrentSlide(index)} className={`transition-all duration-200 rounded-full ${currentSlide === index ? 'bg-white w-6 h-2' : 'bg-white/50 w-2 h-2'}`} aria-label={`Slide ${index + 1}`} />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
